import doctorModule from "./module";

export default doctorModule.saga;
